// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"kw-z","smallCardRow":"lw-z","largeCardRow":"mw-z","productSearchRow":"nw-z","curatedRow":"ow-z"};